export const PATH_KNOWLEDGE = '/oxy365';
export const PATH_KNOWLEDGE_ARTICLE = '/oxy365/:article';
